<template>
  <div class="content work_flow_wrap">
    <!-- 筛选区（SearchBar 组件，样式基准 productInformation；标签名称/启用状态在"更多筛选"折叠行） -->
    <search-bar
      v-model="query"
      :conditions="conditions"
      @search="search"
      @reset="reset"
      @height-change="recalcLayout"
    ></search-bar>
    <div class="button-area">
      <el-button size="mini" type="info" @click="toEdit()">新建</el-button>
    </div>

    <!-- 列表 -->
    <div class="back-color-fff content-main-box" ref="tableBox" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (query.pageIndex - 1) * query.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
      <el-table-column prop="dataModalName" label="数据模态" width="100"></el-table-column>
      <el-table-column prop="examTypeName" label="检查类型或解剖部位" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="labelName" label="病灶或疾病实体" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="启用状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enableState === 'Y' ? 'success' : 'info'" size="small">
            {{ scope.row.enableState === "Y" ? "开启" : "关闭" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" width="90"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="更新人" width="90">
        <template slot-scope="scope">{{ scope.row.updateUserName || "-" }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="160">
        <template slot-scope="scope">{{ scope.row.updateUserName ? formatTime(scope.row.updateTime) : "-" }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="toggleState(scope.row)">
            {{ scope.row.enableState === "Y" ? "停用" : "启用" }}
          </el-button>
          <el-button type="text" class="danger" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      </el-table>

      <el-pagination
        ref="pager"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="query.pageIndex"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar";

export default {
  name: "labelTemplateConf",
  components: { SearchBar },
  data() {
    return {
      // 引导估值：el-table 以 0 起步再在 mounted 里改值会丢高度更新（表格压成 0），先给非 0 初值，挂载后 recalcLayout 实测校正
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 250,
      dataModalOptions: [],
      examTypeOptions: [],
      query: {
        dataModalGuid: "",
        examTypeGuid: "",
        labelName: "",
        enableState: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      tableLoading: false,
    };
  },
  computed: {
    conditions() {
      return [
        // 字典接口返回 guid/text 字段，optLabel/optValue 指定取值列
        { key: "dataModalGuid", label: "数据模态", type: "select", options: this.dataModalOptions, optLabel: "text", optValue: "guid" },
        { key: "examTypeGuid", label: "检查类型或部位", type: "select", options: this.examTypeOptions, optLabel: "text", optValue: "guid" },
        { key: "labelName", label: "病灶或疾病实体", type: "input" },
        {
          key: "enableState",
          label: "启用状态",
          type: "select",
          more: true,
          options: [
            { label: "启用", value: "Y" },
            { label: "停用", value: "N" },
          ],
        },
      ];
    },
  },
  mounted() {
    this.recalcLayout();
    window.addEventListener("resize", this.recalcLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcLayout);
  },
  created() {
    this.initDict();
    this.search();
  },
  methods: {
    // 高度锚点实测：以内容盒顶部为锚，免去 header/条件行等魔法数；底部留 8px；取整避免小数像素
    recalcLayout() {
      if (!this.$refs.tableBox) return;
      const top = this.$refs.tableBox.getBoundingClientRect().top;
      this.contentMainHeight = Math.floor(window.innerHeight - top - 8);
      this.tableHeight = Math.floor(this.contentMainHeight - this.$refs.pager.$el.offsetHeight - 2);
      // 兜底：el-table 的 height watcher 有首帧丢更新场景（prop 已变而内部 layout 不动），nextTick 强制重设一次，已一致时幂等
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.layout.setHeight(this.tableHeight);
      });
    },
    formatTime(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    initDict() {
      // 数据模态/检查类型字典项（取 guid 供模板关联；检查类型字典项运营自维护）
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=数据模态`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dataModalOptions = res.data.data || [];
          }
        });
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=检查类型或解剖部位`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.examTypeOptions = res.data.data || [];
          }
        });
    },
    search() {
      this.tableLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/label-template/page-list`, this.query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableData = res.data.data.records || [];
            // 分页总数字段为 totalRows（FOUR-2966：读 total 恒 undefined 兜底 0 致“共 0 条”）
            this.total = res.data.data.totalRows || res.data.data.total || 0;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.query = {
        dataModalGuid: "",
        examTypeGuid: "",
        labelName: "",
        enableState: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      };
      this.search();
    },
    pageChange(page) {
      this.query.pageIndex = page;
      this.search();
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.search();
    },
    toEdit(row) {
      this.$router.push({
        path: "/labelTemplateEdit",
        query: row && row.guid ? { guid: row.guid } : {},
      });
    },
    toggleState(row) {
      const target = row.enableState === "Y" ? "N" : "Y";
      const text = target === "N" ? "停用" : "启用";
      this.$confirm(`确定${text}该标签吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/label-template/update-state?guid=${row.guid}&enableState=${target}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success(text + "成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || text + "失败");
            }
          });
      });
    },
    onDelete(row) {
      this.$confirm("确定删除该标签吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/label-template/delete?guid=${row.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
      });
    },
  },
};
</script>

<style scoped>
.danger {
  color: #f56c6c;
}
/* 操作列竖线分隔（对齐 certAuditManage 定的标准）：紧凑间距、竖线继承 teal；限表格内防误伤弹框按钮 */
.content /deep/ .el-table .el-button + .el-button {
  margin-left: 4px;
}
.content /deep/ .el-table .el-button + .el-button::before {
  content: "|";
  display: inline-block;
  margin-right: 4px;
  color: #4fa1a4 !important;
}
</style>
